import script from "./EventCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=ddb95f54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddb95f54"]])

export default __exports__